"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hex2val = exports.hex2rgb = exports.hex2hsl = exports.colorParser = exports.colorBrightness = exports.alpha2hex = void 0;
exports.hexNoAlpha = hexNoAlpha;
exports.rgb2hsv = exports.rgb2hsl = exports.rgb2hex = exports.rgb2css = exports.perceivedBrightness = exports.hsv2rgb = exports.hsv2hsl = exports.hsl2rgb = exports.hsl2hsv = exports.hsl2css = void 0;
exports.setRGBAtoZeroIfNull = setRGBAtoZeroIfNull;
exports.val2hex = void 0;
exports.validateAlpha = validateAlpha;
exports.validateHexCode = validateHexCode;
exports.validateRGB = validateRGB;
const hex2rgb = hex => {
  // now with more cowbell. and alpha support.
  // supports 3, 4, 6, and 8 character hex codes.
  let r = -1;
  let g = -1;
  let b = -1;
  let a = -1;
  if (!validateHexCode(hex, true)) {
    r = null;
    g = null;
    b = null;
    return {
      r,
      g,
      b
    };
  }
  const hexParse = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, (_m, r, g, b, a) => "#" + r + r + g + g + b + b + a + a).substring(1).match(/.{2}/g);
  if (hexParse) {
    const vals = hexParse.map(x => {
      return parseInt(x, 16);
    });
    r = +vals[0];
    g = +vals[1];
    b = +vals[2];
    a = +(vals[3] / 255).toFixed(2);
  }
  return {
    r,
    g,
    b,
    a: isNaN(a) || a < 0 ? undefined : a
  };
};
exports.hex2rgb = hex2rgb;
const rgb2hex = values => {
  const {
    r,
    g,
    b,
    a
  } = setRGBAtoZeroIfNull(values);
  let hex = "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  if (a !== undefined && a > -1 && a < 1) {
    hex += alpha2hex(a);
  }
  return hex;
};

// http://alienryderflex.com/hsp.html
exports.rgb2hex = rgb2hex;
const perceivedBrightness = (r, g, b) => Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

// lifted/modified from https://awik.io/determine-color-bright-dark-using-javascript/
exports.perceivedBrightness = perceivedBrightness;
const colorBrightness = color => {
  let returnVal;
  if (/^rgb/.exec(color)) {
    const clr = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/.exec(color);
    if (clr) {
      returnVal = perceivedBrightness(+clr[1], +clr[2], +clr[3]);
    }
  } else {
    const {
      r,
      g,
      b
    } = setRGBAtoZeroIfNull(hex2rgb(color));
    returnVal = perceivedBrightness(r, g, b);
  }
  return returnVal;
};
exports.colorBrightness = colorBrightness;
const hsv2hsl = function (h, s, v) {
  let l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : v - v * s / 2;
  let m = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Math.min(l, 1 - l);
  const newS = m ? (v - l) / m : 0;
  return {
    h,
    s: newS,
    l
  };
};
exports.hsv2hsl = hsv2hsl;
const hsl2hsv = function (h, s, l) {
  let v = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : s * Math.min(l, 1 - l) + l;
  const news = v ? 2 - 2 * l / v : 0;
  return {
    h,
    s: news,
    v
  };
};
exports.hsl2hsv = hsl2hsv;
const hsv2rgb = values => {
  let {
    h
  } = values;
  const {
    s,
    v
  } = values;
  h = h / 360;
  let r = 0;
  let g = 0;
  let b = 0;
  const i = Math.floor(h * 6);
  const f = h * 6 - i;
  const p = v * (1 - s);
  const q = v * (1 - f * s);
  const t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0:
      r = v, g = t, b = p;
      break;
    case 1:
      r = q, g = v, b = p;
      break;
    case 2:
      r = p, g = v, b = t;
      break;
    case 3:
      r = p, g = q, b = v;
      break;
    case 4:
      r = t, g = p, b = v;
      break;
    case 5:
      r = v, g = p, b = q;
      break;
  }
  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255)
  };
};
exports.hsv2rgb = hsv2rgb;
const rgb2hsv = values => {
  const {
    r,
    g,
    b
  } = values;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const d = max - min;
  let h = 0;
  const s = max === 0 ? 0 : d / max;
  const v = max / 255;
  switch (max) {
    case min:
      h = 0;
      break;
    case r:
      h = g - b + d * (g < b ? 6 : 0);
      h /= 6 * d;
      break;
    case g:
      h = b - r + d * 2;
      h /= 6 * d;
      break;
    case b:
      h = r - g + d * 4;
      h /= 6 * d;
      break;
  }
  return {
    h: 360 * h,
    s,
    v
  };
};
exports.rgb2hsv = rgb2hsv;
const hex2hsl = hex => {
  const rgb = setRGBAtoZeroIfNull(hex2rgb(hex));
  const hsv = rgb2hsv(rgb);
  const hsl = hsv2hsl(hsv.h, hsv.s, hsv.v);
  return {
    ...hsl,
    a: rgb.a
  };
};
exports.hex2hsl = hex2hsl;
const hsl2rgb = hsl => {
  const hsv = hsl2hsv(hsl.h, hsl.s, hsl.l);
  return hsv2rgb(hsv);
};
exports.hsl2rgb = hsl2rgb;
const rgb2hsl = rgb => {
  const hsv = rgb2hsv(rgb);
  return hsv2hsl(hsv.h, hsv.s, hsv.v);
};
exports.rgb2hsl = rgb2hsl;
const rgb2css = rgb => {
  const {
    r,
    g,
    b,
    a
  } = rgb;
  return `rgb${a ? "a(" : "("}${r}, ${g}, ${b}${a !== undefined && a > -1 ? `, ${a})` : ")"}`;
};
exports.rgb2css = rgb2css;
const hsl2css = hsl => {
  const {
    h,
    s,
    l,
    a
  } = hsl;
  return `hsl${a ? "a(" : "("}${h}, ${s * 100}%, ${l * 100}%${a ? `, ${a})` : ")"}`;
};

// number/hex value converters (meant for converting alpha)
exports.hsl2css = hsl2css;
const val2hex = val => val.toString(16).padStart(2, "0");
exports.val2hex = val2hex;
const hex2val = hex => parseInt(hex, 16);
// val must be between 0 and 1
exports.hex2val = hex2val;
const alpha2hex = val => {
  let v = val;
  if (v > 1) {
    v = val * 0.01;
  }
  return val2hex(Math.round(v * 255));
};

//Color converter--one space in, all spaces out, regardless which space is being given
exports.alpha2hex = alpha2hex;
const colorParser = color => {
  let colorDefinitions = {
    r: -1,
    g: -1,
    b: -1,
    a: undefined,
    h: -1,
    s: -1,
    l: -1,
    rgba: "",
    hsla: "",
    hex: ""
  };
  if (validateHexCode(color, true)) {
    //hex color
    const rgb = setRGBAtoZeroIfNull(hex2rgb(color));
    const hsl = rgb2hsl(rgb);
    colorDefinitions = {
      ...colorDefinitions,
      hex: color,
      ...rgb,
      ...hsl,
      rgba: rgb2css({
        ...rgb,
        a: rgb.a
      }),
      hsla: hsl2css({
        ...hsl,
        a: undefined
      })
    };
  } else if (/^rgb[a]?\(.*?\)/.test(color)) {
    //rgb(a) color
    const vals = color.replace(/rgb[a]?\(|\)[;]?|\s+/g, "").split(",");
    vals.forEach((v, i) => {
      if (v.match(/%/g)) {
        const val = parseInt(v) * 0.01;
        if (i === 3) {
          colorDefinitions.a = val;
        } else {
          colorDefinitions[["r", "g", "b"][i]] = 255 * val;
        }
      } else {
        colorDefinitions[["r", "g", "b", "a"][i]] = +v;
      }
    });
    const {
      r,
      g,
      b,
      a
    } = colorDefinitions;
    if (r > -1 && g > -1 && b > -1) {
      const hsl = rgb2hsl({
        r,
        g,
        b
      });
      colorDefinitions = {
        ...colorDefinitions,
        hex: rgb2hex({
          r,
          g,
          b
        }),
        ...hsl,
        rgba: rgb2css({
          r,
          g,
          b,
          a
        }),
        hsla: hsl2css({
          ...hsl,
          a
        })
      };
    }
  } else if (/^hsl[a]?\(.*?\)/.test(color)) {
    //hsl(a) color
    const vals = color.replace(/hsl[a]?\(|\)[;]?|\s+/g, "").split(",");
    colorDefinitions.h = +vals[0];
    colorDefinitions.s = parseInt(vals[1]) * 0.01;
    colorDefinitions.l = parseInt(vals[2]) * 0.01;
    if (vals[3] !== undefined) {
      colorDefinitions.a = vals[3].match(/%/g) ? parseInt(vals[3]) * 0.01 : +vals[3];
    }
    const {
      h,
      s,
      l,
      a
    } = colorDefinitions;
    if (h > -1 && s > -1 && l > -1) {
      const rgb = hsl2rgb({
        h,
        s,
        l
      });
      colorDefinitions = {
        ...colorDefinitions,
        ...rgb,
        hex: rgb2hex(rgb),
        rgba: rgb2css({
          ...rgb,
          a
        }),
        hsla: hsl2css({
          h,
          s,
          l,
          a
        })
      };
    }
  }
  return colorDefinitions;
};
exports.colorParser = colorParser;
function setRGBAtoZeroIfNull(values) {
  const isEmpty = Object.values(values).some(x => x === null);
  if (isEmpty) {
    values.r = 0;
    values.g = 0;
    values.b = 0;
  }
  return values;
}

/* Validators */

function validateHexCode(code, allowOpacity) {
  if (allowOpacity) {
    return /^#(?:[0-9a-fA-F]{2}){3,4}$/i.test(code);
  } else {
    return /^#(?:[0-9a-fA-F]{2}){3}$/i.test(code);
  }
}
function validateRGB(value) {
  const val = Number(value);
  if (val < 0 || val > 255 || isNaN(val)) {
    return false;
  } else {
    return true;
  }
}
function validateAlpha(value) {
  const val = Number(value);
  if (val < 0 || val > 100 || isNaN(val)) {
    return false;
  } else {
    return true;
  }
}
function hexNoAlpha(value) {
  if (value.length === 9) {
    // #rrggbbaa -> #rrggbb
    return value.substring(0, 7);
  } else if (value.length === 5) {
    // #rgba  -> #rgb
    return value.substring(0, 4);
  } else {
    return value;
  }
}
//# sourceMappingURL=colorUtilities.js.map